import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Translations } from '@app/core/services/i18n/translations.service';
import { PathDistanceUnits, PathSpeedUnits } from '@app/modules/location/models/path-api.model';
import { SettingsFacade } from '@app/modules/settings/facade/settings.facade';
import { ResourceLoadState } from '@app/store/filters/models/resource-load.state';
import { Settings } from '@app/store/settings/reducers/settings.reducer';
import { TranslateService } from '@livemaps/i18n';
import { filter, skip, take } from 'rxjs';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  @Input() isMobileView = false;
  translated;
  settings;
  distanceUnitOpts = [PathDistanceUnits.KM, PathDistanceUnits.MI];
  speedUnitOpts = [PathSpeedUnits.KPH, PathSpeedUnits.MPH];
  dateFormatOpts = [
    { value: 'dd/MM/yyyy', viewValue: 'DD/MM/YYYY' },
    { value: 'MM/dd/yyyy', viewValue: 'MM/DD/YYYY' }
  ];
  assetViewOptions;

  settingsForm!: FormGroup;

  constructor(
    public translateService: TranslateService,
    public translations: Translations,
    public settingsFacade: SettingsFacade,
    public fb: FormBuilder
  ) {
    this.translations.translationsLoadState
      .pipe(filter(loadstate => loadstate === ResourceLoadState.LOAD_SUCCESSFUL))
      .subscribe(() => {
        this.translated = this.translateService.instant([
          this.translations.settings.speedSettingDescription,
          this.translations.settings.speedDisplay,
          this.translations.settings.distanceUnitSelection,
          this.translations.settings.dateformatSeletion,
          this.translations.settings.displayVehicleNameSelection,
          this.translations.settings.nameDisplay,
          this.translations.settings.distanceUnit,
          this.translations.settings.speedUnit,
          this.translations.sidenav.settings,
          this.translations.settings.vehicleReference,
          this.translations.settings.vrn,
          this.translations.settings.driverActivities,
          this.translations.settings.elapsedTime,
          this.translations.settings.beataFeature
        ]);

        this.settings = this.translated[this.translations.sidenav.settings];

        this.assetViewOptions = [
          { value: 'VRN', viewValue: this.translated[this.translations.settings.vrn] },
          { value: 'REF_NAME', viewValue: this.translated[this.translations.settings.vehicleReference] }
        ];
      });
  }

  ngOnInit(): void {
    this.settingsForm = this.fb.group({
      showVehicleSpeed: [false],
      distanceUnit: [PathDistanceUnits.KM],
      speedUnit: [PathSpeedUnits.KPH],
      dateFormat: ['dd/MM/yyyy'],
      assetViewType: ['VRN'],
      elapsedTime: [false]
    });

    this.registerUserSettings();
    this.watchFormChanges();
  }

  registerUserSettings() {
    this.settingsFacade
      .getDisplaySettings()
      .pipe(take(1))
      .subscribe(settings => {
        this.settingsForm.patchValue(
          {
            showVehicleSpeed: settings.showVehicleSpeed,
            distanceUnit: settings.distanceUnit,
            speedUnit: settings.speedUnit,
            dateFormat: settings.dateFormat,
            assetViewType: settings.assetViewType,
            elapsedTime: settings.elapsedTime
          },
          { emitEvent: false }
        );
      });
  }

  watchFormChanges() {
    this.settingsForm.valueChanges.subscribe(settings => {
      this.settingsFacade.setUserSettings(settings as Settings);
    });
  }
}
